export default __webpack_public_path__ + "static/media/Arya.d31fc656.jpeg";